let course = [
    {
        path: '/course/chapter',
        name: 'list',
        component: () => import('@/views/course/chapter/list.vue'),
        meta: {keepAlive: true, parentPath: 'course'},
    },
    {
        path: '/course/chapter/edit',
        name: 'edit',
        component: () => import('@/views/course/chapter/edit.vue'),
        meta: {keepAlive: true, parentPath: 'course'},
    },
    {
        path: '/course/author/edit',
        name: 'edit',
        component: () => import('@/views/course/author/edit.vue'),
        meta: {keepAlive: true, parentPath: 'course'},
    },
    {
        path: '/course/author',
        name: 'list',
        component: () => import('@/views/course/author/list.vue'),
        meta: {keepAlive: true, parentPath: 'course'},
    }
    ,
    {
        path: '/course/coursefor',
        name: 'coursefor',
        component: () => import('@/views/course/coursefor.vue'),
        meta: {keepAlive: true, parentPath: 'course'},
    }

    
    
]
export default course


// WEBPACK FOOTER //
// ./src/router/course.js